export default {"src":"/_next/static/media/link.76b648c7.svg","height":24,"width":72,"blurWidth":0,"blurHeight":0};